import RateConvertModalContent from "@/components/modal/rate-convert-modals/components/rate-convert-modal-content";

type DislikeConvertModalProps = {
  convertId: string;
};

const DislikeConvertModal = ({ convertId }: DislikeConvertModalProps) => {
  const ratePresets = [
    "Robotic/Unnatural Sounding",
    "Does not sound like the target voice",
    "Low quality or distorted (Artifacts, Noise)",
    "Pitch jumping",
    "Poor pronunciation or articulation",
    "Audio drops out to silence",
    "Popping or bleeping",
    "Other",
  ];
  return (
    <RateConvertModalContent
      ratePresets={ratePresets}
      type={"dislike"}
      convertId={convertId}
    />
  );
};

export default DislikeConvertModal;
